import { AppId } from '@inno-tools/container-bridge'
import { useLocation, useNavigate } from 'react-router-dom'
import { useHistory } from 'shared/hooks/useHistory'
import { useUserContext } from 'shared/hooks/useUserContext'

import { useAvailableApps } from '../hooks/useAvailableApps'
import { FullPageAppTemplate } from '../templates'

const ClusterCodeApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const history = useHistory()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()
  return (
    <FullPageAppTemplate
      appId={AppId.CLUSTER_CODE}
      scope='cluster_code'
      envKey={apps[AppId.CLUSTER_CODE].runtimeEnvKey}
      entryPath='./ClusterCodeApp'
      url={process.env.REACT_APP_CLUSTER_CODE_APP_DEV_PATH}
      hasFullHeight
      appName={apps[AppId.CLUSTER_CODE].name}
      appProps={{
        user,
        initialPath: apps[AppId.CLUSTER_CODE].path,
        defaultHistory: history,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}

export { ClusterCodeApp }
